import React from "react";
import { Outlet } from "react-router-dom";

const CargoInfo: React.FC = () => {
  return <Outlet />;
};

export default CargoInfo;